import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { register as registerApi } from '../../services/authService'
import Button from '../../components/common/Button'
import './styles.scss'

export default function Register() {
  const [formData, setFormData] = useState({
    fullName: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  })
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const { login } = useAuth()
  const navigate = useNavigate()

  const handleChange = (e) => {
    const { id, value } = e.target
    setFormData(prev => ({
      ...prev,
      [id]: value
    }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)

    // Validation
    if (formData.fullName.trim().length < 4) {
      return setError('Full name must be at least 4 characters')
    }

    if (formData.password !== formData.confirmPassword) {
      return setError('Passwords do not match')
    }

    if (formData.password.length < 6) {
      return setError('Password must be at least 6 characters')
    }

    setLoading(true)

    try {
      const data = await registerApi({
        fullName: formData.fullName,
        username: formData.username,
        email: formData.email,
        password: formData.password
      })

      if (data.success) {
        // Auto-login after registration or redirect to login
        // If the backend returns a token on register, use it
        if (data.token) {
          login(data.token, data.user)
          navigate('/')
        } else {
          navigate('/login', { state: { message: 'Registration successful! Please sign in.' } })
        }
      } else {
        setError(data.message || 'Registration failed')
      }
    } catch (err) {
      setError(err.message || 'An error occurred during registration')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="register-container">
      <div className="register-card">
        <div className="register-header">
          <h1 className="register-title">Create Account</h1>
          <p className="register-subtitle">Join the Linqra Advising platform</p>
        </div>

        <form className="register-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input
              id="fullName"
              type="text"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Enter your full name"
              required
              autoComplete="name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={formData.username}
              onChange={handleChange}
              placeholder="Pick a unique username"
              required
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="name@company.com"
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              required
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              id="confirmPassword"
              type="password"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="••••••••"
              required
              autoComplete="new-password"
            />
          </div>

          {error && <div className="register-error">⚠️ {error}</div>}

          <Button
            type="submit"
            fullWidth
            loading={loading}
            className="btn-register"
          >
            Create Account
          </Button>
        </form>

        <div className="register-link">
          <p>Already have an account? <Link to="/login">Sign In</Link></p>
        </div>
        <div className="register-footer">
          <p>Linqra Advising &bull; Academic Intelligence Platform</p>
        </div>
      </div>
    </div>
  )
}
